/* eslint-disable space-before-function-paren */
import React, {
  useEffect,
  useState,
  useImperativeHandle,
  forwardRef,
  useRef
} from 'react';
// eslint-disable-next-line import/no-named-as-default
import useSound from 'use-sound';
import beep1 from '../../assets/sounds/beep1.mp3';
import beep2 from '../../assets/sounds/beep2.mp3';
import beep3 from '../../assets/sounds/beep3.mp3';
import beep4 from '../../assets/sounds/beep4.mp3';
import beep1c from '../../assets/sounds/beep1c.mp3';
import moment from 'moment';
import 'moment/locale/es';
import { pl } from 'date-fns/locale';

const RepChrono = forwardRef((props, ref) => {
  const [diff, setDiff] = useState(null);
  const [initial, setInitial] = useState(null);
  const [concentric, setConcentric] = useState(true);
  const [eccentric, setEccentric] = useState(false);
  const [squeeze, setSqueeze] = useState(false);
  const [startChrono, setStartChrono] = useState(false);

  // Refs para acceder a los valores actuales dentro de tick()
  const concentricRef = useRef(concentric);
  const eccentricRef = useRef(eccentric);
  const squeezeRef = useRef(squeeze);

  // Sincronizar refs con estados
  useEffect(() => {
    concentricRef.current = concentric;
  }, [concentric]);

  useEffect(() => {
    eccentricRef.current = eccentric;
  }, [eccentric]);

  useEffect(() => {
    squeezeRef.current = squeeze;
  }, [squeeze]);

  useEffect(() => {
    start();
  }, []);

  const start = () => {
    if (!startChrono) {
      setInitial(+new Date());
      setStartChrono(true);
    }
    if (startChrono) setStartChrono(false);
  };

  useEffect(() => {
    if (!props.isSetsType) {
      if (concentric) {
        playBeep2();
      } else if (eccentric) {
        playBeep3();
      } else if (squeeze) {
        playBeep4();
      }
    } else if (props.isSetsType) {
      playBeep1c();
    }
  }, [eccentric, concentric, squeeze]);

  const [playBeep1] = useSound(beep1);
  const [playBeep1c] = useSound(beep1c);
  const [playBeep2] = useSound(beep2);
  const [playBeep3] = useSound(beep3);
  const [playBeep4] = useSound(beep4);

  const tick = () => {
    const update = Date.now() - initial;
    const ss = Math.floor((update % 60000) / 1000)
      .toString()
      .padStart(2, '0');
    let total;

    const formatProgress = (ms) => {
      const seconds = Math.floor(ms / 1000);
      const milliseconds = ms % 1000;
      return seconds.toString() + milliseconds.toString().padStart(3, '0');
    };

    if (concentricRef.current) {
      total = props.concentric;
      props.handleProgress(formatProgress(update), total * 1000, 'concentric');
    }
    if (eccentricRef.current) {
      total = props.eccentric;
      props.handleProgress(formatProgress(update), total * 1000, 'eccentric');
    }
    if (squeezeRef.current) {
      total = props.squeeze;
      props.handleProgress(formatProgress(update), total * 1000, 'squeeze');
    }
    if (props.isSetsType) {
      if (
        parseInt(ss) === props.concentric ||
        parseInt(ss) === props.eccentric
      ) {
        setInitial(+new Date());
        if (concentricRef.current) {
          setConcentric(false);
          setEccentric(true);
        } else if (eccentricRef.current) {
          setEccentric(false);
          setConcentric(true);
        }
        props.handleReps();
      }
    } else {
      if (parseInt(ss) === props.concentric && concentricRef.current) {
        setInitial(+new Date());
        setConcentric(false);
        if (props.squeeze) {
          setSqueeze(true);
        } else {
          setEccentric(true);
        }
        props.handleReps();
      } else if (parseInt(ss) === props.squeeze && squeezeRef.current) {
        setInitial(+new Date());
        setSqueeze(false);
        setEccentric(true);
      } else if (parseInt(ss) === props.eccentric && eccentricRef.current) {
        setInitial(+new Date());
        setEccentric(false);
        setConcentric(true);
      }
    }

    setDiff(update);
  };

  useEffect(() => {
    let timer;
    if (startChrono) {
      timer = setInterval(() => {
        tick();
      }, 100); // o 1000ms si sólo quieres precisión de segundos
    }
    return () => clearInterval(timer);
  }, [startChrono, initial]);

  const timeFormat = (date) => {
    if (!date) return '00:00';

    const mm = Math.floor(diff / 60000)
      .toString()
      .padStart(2, '0');
    const ss = Math.floor((diff % 60000) / 1000)
      .toString()
      .padStart(2, '0');
    const ms =
      Math.floor((diff % 1000) / 100)
        .toString()
        .padStart(1, '0') + '0';
    return `${ss}:${ms}`;
  };

  useImperativeHandle(ref, () => ({
    reset() {
      setConcentric(true);
      setEccentric(false);
      setSqueeze(false);
      // También actualizar las refs inmediatamente
      concentricRef.current = true;
      eccentricRef.current = false;
      squeezeRef.current = false;
    }
  }));

  return (
    <div className='App' onClick={start}>
      {timeFormat(diff)}
    </div>
  );
});

export default RepChrono;
